import routerOptions0 from "/home/node/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.4.1_@types+node@22.5.2_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_jq7chgbtrfqzbn3jqh4wcsidti/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}